import { CbhIcon } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { type FileMessage, type UserMessage } from "@sendbird/chat/message";
import { type EveryMessage } from "@sendbird/uikit-react/types/types";
import { type CoreMessageType } from "@sendbird/uikit-react/types/utils";

import { CustomMessageTypes } from "../type";
import { type ChatChannel } from "../types";
import {
  parseAgentChatMessage,
  parseShiftInviteChatMessage,
  shiftTimeProposalDisplayMessage,
} from "../utils";
import { getSendHomeRequestMessage } from "./getSendHomeRequestMessage";

export function getLastMessageInfo(channel: ChatChannel, currentUserId?: string) {
  const { lastMessage } = channel;

  if (!isDefined(lastMessage)) {
    return "No messages";
  }

  if (lastMessage.customType === CustomMessageTypes.SHIFT_BOOKED) {
    return parseAgentChatMessage(lastMessage as CoreMessageType);
  }

  if (
    [CustomMessageTypes.SHIFT_INVITE_REQUEST, CustomMessageTypes.SHIFT_INVITE_RESPONSE].includes(
      lastMessage.customType as CustomMessageTypes
    )
  ) {
    const { agentMessage } = parseShiftInviteChatMessage({
      message: lastMessage as EveryMessage,
    });
    return agentMessage;
  }

  if (
    [
      CustomMessageTypes.SHIFT_TIME_PROPOSAL_CREATED,
      CustomMessageTypes.SHIFT_TIME_PROPOSAL_UPDATED,
      CustomMessageTypes.SHIFT_TIME_PROPOSAL_REPLIED,
    ].includes(lastMessage?.customType as CustomMessageTypes)
  ) {
    return shiftTimeProposalDisplayMessage(lastMessage?.customType as CustomMessageTypes);
  }

  if (lastMessage?.customType === CustomMessageTypes.WORKER_CREDENTIAL_SHARED) {
    return "Shared charting login with you";
  }

  if (lastMessage?.customType === CustomMessageTypes.FCM_REQUEST) {
    const data = (lastMessage.data ? JSON.parse(lastMessage.data) : {}) as {
      facilityName?: string;
    };
    return getSendHomeRequestMessage(data.facilityName);
  }

  const nonAdminLastMessage = lastMessage as unknown as UserMessage | FileMessage;

  const fromText =
    isDefined(currentUserId) && nonAdminLastMessage?.sender?.userId === currentUserId ? "You:" : "";

  if (lastMessage?.messageType === "file") {
    const fileName = (lastMessage as FileMessage)?.name ?? "";

    return (
      <>
        <CbhIcon size="xSmall" type="document" /> {fromText} {fileName}
      </>
    );
  }

  const messageText = (lastMessage as UserMessage)?.message ?? "";

  return (
    <>
      {fromText} {messageText}
    </>
  );
}
